import type { SVGProps } from 'react';
const DawnFlagSG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 2a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
    />
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M20 .5H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h18a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 20 .5M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
    <mask
      id="dawn-flag-SG_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-SG_svg__a)">
      <path fill="#E12237" d="M0 8.533h22V0H0z" />
      <path
        fill="#fff"
        d="M5.239 7.467c.742 0 1.425-.263 1.962-.701a2.6 2.6 0 0 1-.915.167c-1.446 0-2.619-1.194-2.619-2.666 0-1.473 1.173-2.667 2.62-2.667.321 0 .63.06.914.167a3.1 3.1 0 0 0-1.962-.7c-1.736 0-3.143 1.432-3.143 3.2 0 1.767 1.407 3.2 3.143 3.2m1.047-3.734a.53.53 0 0 1-.524.534.53.53 0 0 1-.523-.534c0-.294.234-.533.523-.533s.524.239.524.533M6.81 6.4c.29 0 .524-.239.524-.533a.53.53 0 0 0-.524-.534.53.53 0 0 0-.524.534c0 .294.235.533.524.533m2.619-.533a.53.53 0 0 1-.524.533.53.53 0 0 1-.524-.533c0-.295.235-.534.524-.534s.524.24.524.534m.524-1.6c.29 0 .524-.24.524-.534a.53.53 0 0 0-.524-.533.53.53 0 0 0-.524.533c0 .295.235.534.524.534M8.38 2.133a.53.53 0 0 1-.523.534.53.53 0 0 1-.524-.534c0-.294.234-.533.524-.533.289 0 .523.239.523.533"
      />
    </g>
  </svg>
);
export default DawnFlagSG;
